(function () {
  var productPath = "/products/dual-headrest-cooling-fans-usb-a";
  var page = document.querySelector(".tk9-fan-page");
  if (!page) return;

  function clearBuyBoxes() {
    document.querySelectorAll("[data-tk9-fan-buy-box], .tk9-fan-buy-anchor").forEach(function (node) {
      node.remove();
    });
  }

  clearBuyBoxes();

  var fulfillmentLabel = "Secure checkout";
  var viewTracked = false;
  var variants = [
    {
      id: 44107734155363,
      key: "one_pack",
      title: "1 Dual-Fan Kit",
      detail: "Best for one seat / one dog",
      lines: ["Use it where your dog rides most"],
      price: "$59.99",
      treatmentDefault: "A",
    },
    {
      id: 44107734188131,
      key: "two_pack",
      title: "2 Dual-Fan Kits",
      detail: "One for each headrest",
      lines: ["Best for larger dogs or multiple dogs", "Covers both sides of the bench"],
      price: "$99.99",
      treatmentDefault: "B",
      badge: "Full Backseat Setup",
      recommended: true,
    },
    {
      id: 44198189924451,
      key: "four_pack",
      title: "4-pack",
      detail: "For multiple cars / families",
      lines: ["Set up another vehicle or keep a spare"],
      price: "$179.99",
      treatmentDefault: "C",
      secondary: true,
    },
  ];
  var campaign = "backseat_cooling_fans_feature";
  var experimentName = "fan_advertorial_atc_abc_202605";
  var allowedTreatments = ["A", "B", "C"];
  var params = new URLSearchParams(window.location.search);
  var forcedTreatment = (params.get("tk9_fan_exp") || params.get("fan_exp") || params.get("abc") || "").toUpperCase();
  var storageKey = "tk9_fan_advertorial_exp";

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function getTreatment() {
    if (allowedTreatments.indexOf(forcedTreatment) !== -1) {
      storageSet(storageKey, forcedTreatment);
      return forcedTreatment;
    }
    var stored = storageGet(storageKey);
    if (allowedTreatments.indexOf(stored) !== -1) return stored;
    var next = allowedTreatments[Math.floor(Math.random() * allowedTreatments.length)];
    storageSet(storageKey, next);
    return next;
  }

  var treatment = getTreatment();
  var treatmentCopy = {
    A: {
      eyebrow: "Choose your setup",
      title: "Start with the airflow coverage you need",
      sub: "Most customers pick the two-pack for both front headrests.",
      defaultKey: "two_pack",
    },
    B: {
      eyebrow: "Full Backseat Setup",
      title: "One for each headrest",
      sub: "Best for larger dogs, multiple dogs, or covering both sides of the bench.",
      defaultKey: "two_pack",
    },
    C: {
      eyebrow: "Ready for warm rides",
      title: "Add moving air before the next drive",
      sub: "Pick the setup that matches how your dog actually rides.",
      defaultKey: "two_pack",
    },
  };
  var selectedDefault = (treatmentCopy[treatment] || treatmentCopy.B).defaultKey;
  document.documentElement.setAttribute("data-tk9-fan-exp", treatment);

  function addStyles() {
    var style = document.getElementById("tk9-fan-atc-live-styles") || document.createElement("style");
    style.id = "tk9-fan-atc-live-styles";
    style.textContent = [
      ".tk9-fan-buy-box{display:grid;gap:14px;margin:20px 0;padding:18px;border:1px solid #d8e1e7;border-radius:8px;background:#fff;box-shadow:0 14px 34px rgba(8,25,38,.12);color:#102a43}",
      ".tk9-fan-buy-box__head{display:grid;gap:6px}",
      ".tk9-fan-buy-box__eyebrow{font-size:.72rem;font-weight:900;letter-spacing:.08em;text-transform:uppercase;color:#2f6f57!important}",
      ".tk9-fan-buy-box__title{font-size:1.08rem;font-weight:900;line-height:1.2;color:#102a43!important}",
      ".tk9-fan-buy-box__sub{margin:0;color:#35495b!important;font-size:.92rem;line-height:1.45;opacity:1!important}",
      ".tk9-fan-variant-grid{display:grid;gap:10px}",
      ".tk9-fan-variant-option{position:relative;display:grid;grid-template-columns:auto 1fr auto;gap:12px;align-items:center;min-height:66px;padding:12px 14px;border:1px solid #d4dde4;border-radius:8px;background:#f8fafb;cursor:pointer;transition:border-color .16s ease,background .16s ease,box-shadow .16s ease,transform .16s ease}",
      ".tk9-fan-variant-option:hover{border-color:#2f6f57;background:#f2f8f5;box-shadow:0 8px 20px rgba(16,42,67,.08);transform:translateY(-1px)}",
      ".tk9-fan-variant-option:has(input:checked){border-color:#2f6f57;background:#ecf8f2;box-shadow:0 0 0 2px rgba(47,111,87,.18),0 10px 22px rgba(47,111,87,.12)}",
      ".tk9-fan-variant-option--recommended{border-color:#2f6f57;background:#edf9f3}",
      ".tk9-fan-variant-option--secondary{background:#fbfcfc}",
      ".tk9-fan-variant-option__badge{display:inline-flex;width:fit-content;margin-bottom:6px;padding:4px 8px;border-radius:999px;background:#2f6f57;color:#fff!important;font-size:.66rem;font-weight:900;letter-spacing:.04em;text-transform:uppercase}",
      ".tk9-fan-variant-option input{width:20px;height:20px;accent-color:#2f6f57}",
      ".tk9-fan-variant-option strong,.tk9-fan-variant-option span{display:block}",
      ".tk9-fan-variant-option strong{font-size:.98rem;line-height:1.2;color:#102a43!important}",
      ".tk9-fan-variant-option small{color:#42586b!important;font-size:.82rem;line-height:1.4;opacity:1!important}",
      ".tk9-fan-variant-option__price{font-weight:900;white-space:nowrap;color:#102a43!important;font-size:1rem}",
      ".tk9-fan-buy-box__footer{display:grid;gap:10px}",
      ".tk9-fan-buy-box__button{appearance:none;display:inline-flex;justify-content:center;align-items:center;min-height:56px;width:100%;padding:15px 18px;border:0;border-radius:8px;background:linear-gradient(180deg,#f2382c 0%,#d82118 100%);color:#fff!important;font:inherit;font-size:.98rem;font-weight:900;line-height:1.2;letter-spacing:0;white-space:normal;text-align:center;cursor:pointer;text-shadow:0 1px 0 rgba(82,13,8,.22);box-shadow:0 14px 28px rgba(225,38,28,.28),inset 0 1px 0 rgba(255,255,255,.28);transition:background .16s ease,transform .16s ease,box-shadow .16s ease}",
      ".tk9-fan-buy-box__button:hover{background:linear-gradient(180deg,#e52c22 0%,#be2119 100%);box-shadow:0 16px 32px rgba(190,33,25,.34),inset 0 1px 0 rgba(255,255,255,.22);transform:translateY(-1px)}",
      ".tk9-fan-buy-box__button:focus-visible{outline:3px solid rgba(225,38,28,.24);outline-offset:3px}",
      ".tk9-fan-buy-box__button[disabled]{cursor:wait;opacity:.72;transform:none}",
      ".tk9-fan-buy-box__note{display:flex;flex-wrap:wrap;justify-content:center;gap:8px 14px;min-height:18px;margin:0;color:#35495b!important;font-size:.8rem;line-height:1.35;opacity:1!important}",
      ".tk9-fan-buy-box__note span{color:#35495b!important;opacity:1!important}",
      ".tk9-fan-buy-box__note strong{color:#102a43!important;font-weight:900}",
      ".tk9-fan-buy-box__fallback{color:#2f6f57!important;font-size:.84rem;font-weight:900;text-align:center;text-decoration:underline}",
      ".tk9-fan-buy-anchor{scroll-margin-top:110px}",
      "@media(max-width:560px){.tk9-fan-buy-box{padding:14px}.tk9-fan-variant-option{grid-template-columns:auto 1fr}.tk9-fan-variant-option__price{grid-column:2}}",
    ].join("");
    if (!style.parentNode) document.head.appendChild(style);
  }

  function money(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return "";
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency }).format(amount / 100);
  }

  function track(eventName, payload) {
    var event = Object.assign(
      {
        event: eventName,
        experiment_name: experimentName,
        experiment_variant: treatment,
        product_handle: "dual-headrest-cooling-fans-usb-a",
        campaign: campaign,
        page_path: window.location.pathname,
      },
      payload || {},
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(eventName, event);
      }
    } catch (error) {}
    try {
      if (typeof window.mpx === "function") window.mpx("track", eventName, event);
    } catch (error) {}
  }

  async function replaceFanSetupVariant(variant, properties) {
    var fanVariantIds = ["44107734155363", "44107734188131", "44198189924451"];
    var cartResponse = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!cartResponse.ok) throw new Error("Cart refresh failed");
    var cart = await cartResponse.json();
    var fanLines = (cart.items || []).filter(function (line) {
      return fanVariantIds.indexOf(String(line.variant_id || line.id || "")) !== -1;
    });

    for (var index = 0; index < fanLines.length; index += 1) {
      var removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: fanLines[index].key,
          quantity: 0,
        }),
      });
      if (!removeResponse.ok) throw new Error("Fan setup replace failed");
    }

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: variant.id,
        quantity: 1,
        properties: properties,
      }),
    });
  }

  function selectedVariant(box) {
    var checked = box.querySelector("input[name^='tk9-fan-variant']:checked");
    return variants.find(function (variant) {
      return String(variant.id) === (checked && checked.value);
    }) || variants[1];
  }

  function buttonLabel(variant) {
    if (!variant) return "Add to Cart";
    if (variant.key === "two_pack") return "Add Full Backseat Setup to Cart - " + variant.price;
    if (variant.key === "one_pack") return "Add 1 Dual-Fan Kit to Cart - " + variant.price;
    return "Add 4-pack to Cart - " + variant.price;
  }

  function updateButton(box) {
    var button = box.querySelector(".tk9-fan-buy-box__button");
    if (!button || button.disabled) return;
    button.textContent = buttonLabel(selectedVariant(box));
  }

  function variantMarkup(variant, placement) {
    return [
      '<label class="tk9-fan-variant-option',
      variant.recommended ? " tk9-fan-variant-option--recommended" : "",
      variant.secondary ? " tk9-fan-variant-option--secondary" : "",
      '">',
      '<input type="radio" name="tk9-fan-variant-',
      placement,
      '" value="',
      variant.id,
      '" ',
      variant.key === selectedDefault ? "checked" : "",
      ">",
      "<span>",
      variant.badge ? '<em class="tk9-fan-variant-option__badge">' + variant.badge + "</em>" : "",
      '<strong data-tk9-fan-variant-title="' + variant.id + '">' + variant.title + "</strong>",
      "<small>",
      variant.detail,
      variant.lines && variant.lines.length ? "<br>" + variant.lines.join("<br>") : "",
      "</small>",
      "</span>",
      '<span class="tk9-fan-variant-option__price" data-tk9-fan-variant-price="' + variant.id + '">' + variant.price + "</span>",
      "</label>",
    ].join("");
  }

  function buildBuyBox(placement) {
    var copy = treatmentCopy[treatment] || treatmentCopy.B;
    var box = document.createElement("form");
    box.className = "tk9-fan-buy-box";
    box.setAttribute("data-tk9-fan-buy-box", "");
    box.setAttribute("data-tk9-placement", placement);
    if (placement === "primary_product") box.id = "tk9-fan-buy-primary";
    box.innerHTML = [
      '<div class="tk9-fan-buy-box__head">',
      '<span class="tk9-fan-buy-box__eyebrow">',
      copy.eyebrow,
      "</span>",
      '<span class="tk9-fan-buy-box__title">',
      copy.title,
      "</span>",
      '<p class="tk9-fan-buy-box__sub">',
      copy.sub,
      "</p>",
      "</div>",
      '<div class="tk9-fan-variant-grid" role="radiogroup" aria-label="Choose a bundle">',
      variants.map(function (variant) { return variantMarkup(variant, placement); }).join(""),
      "</div>",
      '<div class="tk9-fan-buy-box__footer">',
      '<button class="tk9-fan-buy-box__button" type="submit">',
      buttonLabel(variants.find(function (variant) { return variant.key === selectedDefault; }) || variants[1]),
      "</button>",
      '<p class="tk9-fan-buy-box__note"><strong>',
      fulfillmentLabel,
      "</strong><span>60-day guarantee</span><span>Review in cart before checkout</span></p>",
      '<a class="tk9-fan-buy-box__fallback" href="',
      productPath,
      '" data-el="fan-feature-20260519-',
      placement,
      '-details">See fan details</a>',
      "</div>",
    ].join("");

    box.addEventListener("change", function () {
      var variant = selectedVariant(box);
      updateButton(box);
      track("tk9_fan_variant_select", {
        placement: placement,
        variant_id: variant.id,
        variant_key: variant.key,
        variant_title: variant.title,
        fulfillment_status: "standard",
      });
    });

    box.addEventListener("submit", async function (event) {
      event.preventDefault();
      var button = box.querySelector("button");
      var note = box.querySelector(".tk9-fan-buy-box__note");
      var variant = selectedVariant(box);
      if (variant.available === false) {
        note.textContent = "That setup is not available right now. Choose another option or view full product details.";
        track("tk9_fan_unavailable_variant_click", {
          placement: placement,
          variant_id: variant.id,
          variant_key: variant.key,
          variant_title: variant.title,
        });
        return;
      }
      button.disabled = true;
      button.textContent = "Adding to Cart...";
      note.innerHTML = "<strong>Adding to cart...</strong><span>We'll open your cart next.</span>";
      track("tk9_fan_add_to_cart_click", {
        placement: placement,
        variant_id: variant.id,
        variant_key: variant.key,
        variant_title: variant.title,
      });

      try {
        var response = await replaceFanSetupVariant(variant, {
          _tk9_page: "backseat-dog-cooling-fans",
          _tk9_campaign: campaign,
          _tk9_experiment: experimentName,
          _tk9_experiment_variant: treatment,
          _tk9_buy_box: placement,
          _tk9_selected_bundle: variant.title,
          _tk9_landing_path: window.location.pathname,
          _tk9_slide_cart_source: "native_slide_cart",
          _tk9_slide_cart_component: "slide_cart",
          _tk9_slide_cart_experiment: "native_slide_cart_launch",
          _tk9_slide_cart_variation: "variation_1",
          _tk9_slide_cart_type: "pdp_add",
          _tk9_slide_cart_id: "fan-advertorial",
        });
        if (!response.ok) throw new Error("Cart add failed");
        var item = await response.json();
        track("tk9_fan_add_to_cart_success", {
          placement: placement,
          variant_id: variant.id,
          variant_key: variant.key,
          variant_title: variant.title,
          cart_item_key: item.key,
        });
        note.innerHTML = "<strong>Added.</strong><span>Opening cart...</span>";
        button.textContent = "Added - Opening Cart";
        window.setTimeout(function () {
          var fallbackUrl = "/cart?tk9_fan_exp=" + encodeURIComponent(treatment);
          if (window.TeamK9SlideCart && typeof window.TeamK9SlideCart.open === "function") {
            window.TeamK9SlideCart.open().catch(function () {
              window.location.href = fallbackUrl;
            });
            return;
          }
          window.location.href = fallbackUrl;
        }, 450);
      } catch (error) {
        track("tk9_fan_add_to_cart_error", {
          placement: placement,
          variant_id: variant.id,
          variant_key: variant.key,
          error_message: (error && error.message) || "unknown",
        });
        note.textContent = "Cart add did not complete. Please try again or view full product details.";
        button.disabled = false;
        button.textContent = buttonLabel(variant);
      }
    });
    updateButton(box);
    return box;
  }

  function refreshLivePrices() {
    fetch(productPath + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        product.variants.forEach(function (liveVariant) {
          var variant = variants.find(function (item) { return item.id === liveVariant.id; });
          if (!variant) return;
          variant.price = money(liveVariant.price) || variant.price;
          variant.available = liveVariant.available !== false;
        });
        document.querySelectorAll("[data-tk9-fan-variant-price]").forEach(function (node) {
          var variant = variants.find(function (item) { return String(item.id) === node.getAttribute("data-tk9-fan-variant-price"); });
          if (variant && variant.price) node.textContent = variant.price;
        });
        document.querySelectorAll("[data-tk9-fan-from-price]").forEach(function (node) {
          var minPrice = product.price_min || product.price || (product.variants[0] && product.variants[0].price);
          var formatted = money(minPrice);
          if (formatted) node.textContent = "From " + formatted;
        });
        document.querySelectorAll("[data-tk9-fan-buy-box]").forEach(updateButton);
      })
      .catch(function () {});
  }

  function polishOldCopy() {
    var heroPrice = page.querySelector(".tk9-fan-price strong");
    var heroPriceSub = page.querySelector(".tk9-fan-price span");
    if (heroPrice) {
      heroPrice.setAttribute("data-tk9-fan-from-price", "");
      heroPrice.textContent = "From $59.99";
    }
    if (heroPriceSub) heroPriceSub.textContent = "One-pack, two-pack, or four-pack. USB-A plug only. 60-day guarantee.";
    page.querySelectorAll("li, span, p").forEach(function (node) {
      var text = node.textContent.trim();
      if (text === "One-pack or two-pack bundle") node.textContent = "One-pack, two-pack, or four-pack";
      if (text === "One-pack or two-pack") node.textContent = "One-pack, two-pack, or four-pack";
      if (text === "Dual fan heads, backseat headrest-area setup, one-pack or two-pack, USB-A plug only.") {
        node.textContent = "Dual fan heads, headrest-area backseat setup, USB-A plug only.";
      }
      if (text === "Choose one-pack or two-pack bundle and save.") node.textContent = "Choose the setup that fits your back seat.";
      if (text === "Choose one-pack or two-pack. Bundle and save if you need wider coverage.") {
        node.textContent = "Choose the setup that fits your back seat.";
      }
    });
    page.querySelectorAll(".tk9-fan-offer-box h3").forEach(function (node) {
      if (/From \$(39|49)\.99/.test(node.textContent.trim())) {
        node.setAttribute("data-tk9-fan-from-price", "");
        node.textContent = "From $59.99";
      }
    });
  }

  function mount() {
    clearBuyBoxes();
    addStyles();
    polishOldCopy();

    var productSection = page.querySelector(".tk9-fan-product > div:last-child");
    var productActions = productSection && productSection.querySelector(".tk9-fan-actions");
    if (productSection) {
      var primaryAnchor = document.createElement("div");
      primaryAnchor.className = "tk9-fan-buy-anchor";
      primaryAnchor.appendChild(buildBuyBox("primary_product"));
      productSection.insertBefore(primaryAnchor, productActions || null);
    }

    var finalBanner = page.querySelector(".tk9-fan-banner");
    var finalActions = finalBanner && finalBanner.querySelector(".tk9-fan-actions");
    if (finalActions) finalBanner.insertBefore(buildBuyBox("final_banner"), finalActions);

    page.querySelectorAll('a[href*="' + productPath + '"]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      var content = url.searchParams.get("utm_content") || "";
      var isDetailsLink = /details|product-details/i.test(content) || /details/i.test(link.textContent);
      if (isDetailsLink) return;
      link.setAttribute("href", "#tk9-fan-buy-primary");
      link.setAttribute("data-tk9-scroll-buy", "");
      if (!link.hasAttribute("data-tk9-scroll-buy-bound")) {
        link.setAttribute("data-tk9-scroll-buy-bound", "true");
        link.addEventListener("click", function () {
          track("tk9_fan_cta_scroll_to_buy", {
            cta_text: link.textContent.trim(),
            original_utm_content: content,
            original_el: url.searchParams.get("el") || "",
          });
        });
      }
    });

    if (!viewTracked) {
      viewTracked = true;
      track("tk9_fan_experiment_view", { default_variant_key: selectedDefault });
    }
    refreshLivePrices();
  }

  function runMounts() {
    mount();
    [250, 1000, 2500].forEach(function (delay) {
      window.setTimeout(mount, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runMounts);
  } else {
    runMounts();
  }
})();
